import { render, staticRenderFns } from "./KartOdeme.vue?vue&type=template&id=69e99558&"
import script from "./KartOdeme.vue?vue&type=script&lang=js&"
export * from "./KartOdeme.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports